module.exports = __webpack_public_path__ + "img/about1.5b97e1f8.jpg";